import { auth, db, FIRESTORE_ID } from '../../plugins/firebase'
import { Devices } from '../../api/modules'

const state = {
    list: [],
    collection: null,
    lastReadings: null,
    ready: false
};

const getters = {
    getMeter: state => meter => state.list.find( m => m.name === meter || m.id === meter ),
    getMetersGtw: state => gateway => state.list.filter(m => m.gateway === gateway),
    getMeterData: state => meter => state.list.find(m => m.name === meter || m.circuit === meter).data,
    getLastReading: state => meter => state.lastReadings.find(m => m.meter === meter),
    getAll: state => state.list.map( m => ({ name: m.name, circuit: m.circuit })),
    getLocations: state => state.list.map( m => m.location )
};

const actions = {
    setNotReady({ commit }){
        commit('SET_READY', false)
        commit('SET_METERS', [])
        commit('UPDATE_LAST_READS', [])
    },
    async init({ commit, dispatch, rootState }){
        return new Promise(async (resolve) =>{
            if(auth.currentUser){
                commit('UPDATE_COLLECTION', {
                    account: rootState.account.id,
                    project: rootState.projects.selected.id
                })
                await dispatch('fetchUserMeters')
                commit('SET_READY', true)
                return resolve()
            }else{
                commit('UPDATE_COLLECTION')
                commit('SET_METERS', [])
                return resolve()
            }
        })
    },
    async fetchUserMeters({ commit }){
        const response = await db.collection(state.collection).get()
        const meters = response.docs.map( meter => meter.data() )
        const meters_formated = meters.map( meter => 
            meter.hasOwnProperty('gain') ? meter : { ...meter, gain: 1 } 
        )
        
        commit('SET_METERS', meters_formated)
    },
    async addMeter({ state, commit }, meter){
        try {
            await Devices.addDevice( meter.id, meter.name )
            await db.doc(`${state.collection}/${meter.id}`).set(meter)
            commit('ADD_METER', meter)
        } catch (error) {
            if(error.response.status === 508){
                await db.doc(`${state.collection}/${meter.id}`).set(meter)
                commit('ADD_METER', meter)
            }
        }
        
        return
    },
    async editMeter({state, commit}, meter){
        const { id } = meter
        delete meter.id

        await Devices.updateDisplayName(id, meter.name)

        await db.doc(`${state.collection}/${id}`).update(meter)
        commit('UPDATE_METER', { id, ...meter })

        return
    },
    deleteMeters({commit, state}, meters){
        return new Promise(async (resolve, reject) => {
            try {
                const requests = meters.map( m => db.doc(`${state.collection}/${m.name}`).delete() )
                let res = await Promise.all(requests)

                commit('DELETE_METERS', meters)
                resolve()
            } catch (error) {
                console.log(error)
                reject()
            }
        })
    },
    async lastReadings({ state, commit }){
        if(state.list.length == 0) return 

        const meters = state.list.map( meter => 
            ({ id: meter.id, gateway: meter.gateway }) 
        )
        
        let batch, promise, requests = [], init = 0, len_batch = 10
        while (meters.length > 0) {
            batch = meters.splice(init, len_batch)
            promise = batch.map( meter => 
                Devices.functionData( meter.id, 'ElectricMeter')
                    .then( res => ({ ...meter ,...res }) )
                    .catch( err => err.response )
            )
            
            requests.push(promise)
        }

        const lastReads = []
        for (const req of requests) {
            const responses = await Promise.all(req)
            responses.forEach( response => {
                if(response.status !== 200) return
                if(Object.keys(response.data.data).length === 0) return
                const data = response.data.data
                data.updated = new Date(data.updated)
                lastReads.push({
                    meter: response.id,
                    gateway: response.gateway,
                    data
                })
            });
        }
        commit('UPDATE_LAST_READS', lastReads)
    },
    queryReadings({ state }, data){
        const meter = state.list.find((m) => m.id === data.meter);
        if(!meter) return null

        return Devices.ElectricMeter.lastData(
            data.meter,
            data.query.len,
            data.query.start,
            data.query.end
        )
        .then(res => ({ meter , ...res}))
        .catch( err => ({ meter, ...err.response}) )
    },
    getSummaryData({ state }, payload ){
        const requests = payload.meters.map( meter => 
            Devices.ElectricMeter.summaryData(
                meter.id,
                payload.type,
                payload.start.getTime()
            )
            .then( res => ({ meter , ...res}))
            .catch( err => ({ meter, ...err.response}) )
        )

        return Promise.all(requests)
    }
};

const mutations = {
    UPDATE_COLLECTION(state, data){
        data.account 
            ? state.collection = `${FIRESTORE_ID}/${data.account}/projects/${data.project}/meters`
            : state.collection = null
    },
    UPDATE_LAST_READS(state, data){
        state.lastReadings = data
    },
    SET_METER_DATA(state, payload) {
        const index = state.list.findIndex((m) => m.name == payload.meter);
        state.list[index].data = payload.data
        state.list[index].last_update = new Date().getTime()
    },
    ADD_METER(state, meter){
        state.list.push(meter)
    },
    DELETE_METERS(state, meters){
        meters.forEach(meter => {
            const index = state.list.findIndex((m) => m.name == meter.name);
            state.list.splice(index, 1)
        })
    },
    UPDATE_METER(state, meter){
        const index = state.list.findIndex( m => m.id === meter.id )
        const state_meter = state.list[index]
        state_meter.name = meter.name
        state_meter.type = meter.type
        state.list.splice(index, 1, state_meter)
    },
    SET_METERS(state, meters){
        if(!meters) return
        state.list = meters
    },
    SET_READY(state, payload){
        state.ready = payload
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
